export default __webpack_public_path__ + "static/media/sbct-left.1aa8a959.jpg";